import { USER_CONFIG } from '@porterin/booking-flow/src/auth/domain/config/user';
import { z as zod } from 'zod';

export const makeSignupFormSchema = (mobile_regex: RegExp) =>
  zod.object({
    name: zod
      .string()
      .min(USER_CONFIG.MIN_NAME_LENGTH, USER_CONFIG.INVALID_NAME)
      .max(USER_CONFIG.MAX_NAME_LENGTH, USER_CONFIG.NAME_TOO_LONG)
      .regex(USER_CONFIG.NAME_REGEX, USER_CONFIG.NAME_SPECIAL_CHARS),
    phone: zod
      .string()
      .min(1, USER_CONFIG.EMPTY_MOBILE)
      .regex(mobile_regex, USER_CONFIG.INVALID_MOBILE),
    email: zod
      .string()
      .min(1, USER_CONFIG.INVALID_EMAIL)
      .email(USER_CONFIG.INVALID_EMAIL),
    whatsappConsent: zod.boolean(),
  });

export const schema = makeSignupFormSchema(USER_CONFIG.PHONE_REGEX);

export type SignupFormValues = zod.infer<typeof schema>;
